<template>
  <div>
    <div
      class="
        tw-pb-0
        tw-px-3
        tw-pt-3
        tw-text-white
        tw-text-2xl
        tw-text-left
        tw-font-normal
      "
    >
      Ferramenta de Texto
    </div>
    <div class="tw-px-3 tw-py-2 tw-flex tw-items-center tw-gap-2">
      <span class="tw-text-white tw-text-base tw-shrink-0">Fonte:</span>
      <select
        v-model="currentFont"
        class="font-select tw-w-auto tw-py-2 tw-px-3 tw-rounded tw-bg-white tw-text-gray-800 tw-text-base tw-cursor-pointer"
      >
        <option
          v-for="f in fonts"
          :key="fontValue(f)"
          :value="fontValue(f)"
          :style="{ fontFamily: fontValue(f) }"
        >
          {{ fontLabel(f) }}
        </option>
      </select>
    </div>
    <div class="tw-px-3 tw-py-2 tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
      <span class="tw-text-white tw-text-base tw-shrink-0">Cor:</span>
      <div class="tw-flex tw-flex-wrap tw-gap-1 tw-items-center">
        <button
          v-for="c in colorOptions"
          :key="c.value"
          type="button"
          class="color-swatch"
          :class="{ 'color-swatch-active': currentColor === c.value }"
          :style="{ backgroundColor: c.value }"
          :title="c.label"
          @click="currentColor = c.value"
        />
        <input
          v-model="currentColor"
          type="color"
          class="color-picker"
          title="Escolher cor"
        />
      </div>
    </div>
    <div class="tw-text-center tw-py-3 tw-flex tw-items-center">
      <div class="tw-flex-1 tw-px-3">
        <input
          class="insert tw-text-lg"
          ref="input"
          v-model="inputText"
          @click="caretClick"
          placeholder="Novo texto"
        />
      </div>
      <div class="tw-flex-none tw-pr-3">
        <!-- tw-h-12 -->
        <button
          class="
            tw-px-8
            tw-py-3
            tw-justify-center
            tw-items-center
            tw-rounded
            tw-shadow
            tw-font-bold
            tw-fill-current
          "
          :class="{
            'tw-bg-gray-400': caseDisabledSend,
            'tw-bg-indigo-700': !caseDisabledSend,
          }"
          :disabled="caseDisabledSend"
          @click="acrescentarTexto()"
        >
          <v-icon color="white">mdi-send</v-icon>
        </button>
      </div>
    </div>
    <div class="simple-keyboard"></div>
  </div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";
import layoutBrazilian from "simple-keyboard-layouts/build/layouts/brazilian.js";

// Adiciona botão "Acentos" e layout com caracteres acentuados
const brDefault = layoutBrazilian.layout.default;
const brShift = layoutBrazilian.layout.shift;
const layout = {
  layout: {
    default: [
      ...brDefault.slice(0, -1),
      brDefault[brDefault.length - 1] + " {acentos}",
    ],
    shift: [
      ...brShift.slice(0, -1),
      brShift[brShift.length - 1] + " {acentos}",
    ],
    acentos: [
      "á à â ã é ê í ó ô õ ú ç",
      "Á À Â Ã É Ê Í Ó Ô Õ Ú Ç",
      "{voltar}",
    ],
  },
  display: {
    "{acentos}": "áéíóú",
    "{voltar}": "← Voltar",
    "{bksp}": "Apagar",
    "{tab}": "Tab",
    "{lock}": "CapsLock",
    "{enter}": "Enter",
    "{shift}": "⇧",
    "{space}": "Espaço",
  },
};

export default {
  data() {
    return {
      instanciaKeyboard: null,
      inputText: null,
      currentCaret: 0,
      shiftOneShot: false,
      currentFont: "Montserrat",
      currentColor: "#000000",
      fonts: [
        "Montserrat",
        "Avelyn",
        "Betrycia",
        "Rocket",
      ],
      colorOptions: [
        { label: "Preto", value: "#000000" },
        { label: "Branco", value: "#ffffff" },
        { label: "Vermelho", value: "#dc2626" },
        { label: "Azul", value: "#2563eb" },
        { label: "Verde", value: "#16a34a" },
        { label: "Amarelo", value: "#eab308" },
        { label: "Rosa", value: "#ec4899" },
        { label: "Roxo", value: "#7c3aed" },
        { label: "Laranja", value: "#ea580c" },
        { label: "Cinza", value: "#6b7280" },
      ],
    };
  },
  computed: {
    caseDisabledSend() {
      return this.inputText == "" || !this.inputText;
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    caretRemove() {
      this.currentCaret -= 1;
      this.instanciaKeyboard.setCaretPosition(this.currentCaret);
    },
    caretClick(e) {
      this.currentCaret = e.target.selectionStart;
      this.instanciaKeyboard.setCaretPosition(this.currentCaret);
    },
    acrescentarTexto() {
      if (this.inputText == "" || !this.inputText) {
        return false;
      }
      this.$emit("onCreateText", {
        font: this.currentFont,
        text: this.inputText,
        color: this.currentColor,
      });
      this.inputText = "";
      this.currentCaret = 0;
      this.instanciaKeyboard.setInput("");
    },
    initialize() {
      let self = this;
      this.instanciaKeyboard = new Keyboard(
        {
          onChange: (input) => self.onChange(input),
          onKeyPress: (button) => self.onKeyPress(button),
          ...layout,
        },
        {
          buttonAttributes: [
            {
              attribute: "aria-label",
              value: "bee",
              buttons: "b B",
            },
          ],
          debug: true,
          disableCaretPositioning: true,
        }
      );
    },
    onChange(input) {
      // Não deixar botões especiais aparecerem no texto
      let cleaned = input;
      if (cleaned.includes("{acentos}")) cleaned = cleaned.replace(/\{acentos\}/g, "");
      if (cleaned.includes("{voltar}")) cleaned = cleaned.replace(/\{voltar\}/g, "");
      if (cleaned !== input) {
        this.instanciaKeyboard.setInput(cleaned);
        input = cleaned;
      }
      // Já recebeu a modificação do caret do teclado.
      this.currentCaret = this.instanciaKeyboard.getCaretPosition();
      this.$refs.input.focus();
      this.inputText = input;
      this.instanciaKeyboard.setCaretPosition(this.currentCaret);
    },
    onKeyPress(button) {
      //antes de receber a modificação do caret
      if (this.currentCaret !== this.instanciaKeyboard.getCaretPosition()) {
        this.instanciaKeyboard.setCaretPosition(this.currentCaret);
      }
      if (button === "{acentos}") {
        this.instanciaKeyboard.setOptions({ layoutName: "acentos" });
        return;
      }
      if (button === "{voltar}") {
        this.instanciaKeyboard.setOptions({ layoutName: "default" });
        this.shiftOneShot = false;
        return;
      }
      if (button === "{shift}") {
        this.shiftOneShot = true;
        this.instanciaKeyboard.setOptions({ layoutName: "shift" });
        return;
      }
      if (button === "{lock}") {
        this.shiftOneShot = false;
        this.handleShift();
        return;
      }
      if (this.shiftOneShot && !button.startsWith("{")) {
        this.instanciaKeyboard.setOptions({ layoutName: "default" });
        this.shiftOneShot = false;
      }
      if (button === "{backspace}") this.caretRemove();
    },
    fontLabel(f) {
      return typeof f === "object" ? f.label : f;
    },
    fontValue(f) {
      return typeof f === "object" ? f.value : f;
    },
    handleShift() {
      let currentLayout = this.instanciaKeyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";
      this.instanciaKeyboard.setOptions({
        layoutName: shiftToggle,
      });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap");
@font-face {
  font-family: "Avelyn";
  src: url("/fonts/avelyn-regular/Avelyn Regular/Avelyn Regular.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Betrycia";
  src: url("/fonts/betrycia/Betrycia.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Rocket";
  src: url("/fonts/rocket_chicken (1)/Rocket Chicken Demo.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}

.hg-theme-default {
  background-color: rgba(230, 230, 230, 0.9);
  border-radius: 0px;
  padding: 5px 10px;
}
</style>

<style lang="scss" scoped>
.font-select {
  outline: none;
  min-height: 44px;
}
.color-swatch {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.5);
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
}
.color-swatch-active {
  border-color: #fff;
  box-shadow: 0 0 0 2px #4f46e5;
}
.color-picker {
  width: 32px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background: transparent;
}
.insert {
  padding: 8px 20px;
  border-radius: 5px;
  outline: none;
  background-color: white;
  width: 100%;
  margin: 5px auto;
  justify-self: center;
  display: inline-block;
}
.input {
  display: none;
}
</style>
